import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-voucher-list',
  templateUrl: './voucher-list.component.html',
  styleUrls: ['./voucher-list.component.scss']
})
export class VoucherListComponent implements OnInit {

  // { client, vouchers, onSelect } passed via BsModal initialState
  message: any;

  // voucher uuid → generated QR code (data URL)
  qrMap: { [uuid: string]: string } = {};

  constructor(private modalService: ModalService) { }

  ngOnInit(): void {
    this.vouchers.forEach((uv) => {
      if (uv?.uuid) {
        QRCode.toDataURL(uv.uuid, { margin: 1, width: 160 })
          .then((url) => { this.qrMap[uv.uuid] = url; })
          .catch(() => { });
      }
    });
  }

  get client(): any { return this.message?.client; }
  get vouchers(): any[] { return this.message?.vouchers || []; }

  select(uv: any): void {
    if (uv?.status !== 'active') { return; }
    this.hideModal();
    if (this.message?.onSelect) {
      this.message.onSelect(uv);
    }
  }

  hideModal(): void {
    this.modalService.hideVoucherList();
  }
}
